import { createProfile, updateProfile } from "../../services/api";
import { reverseNormalizeUserData } from "./normalization";

export default function useFormSubmit(medstarAssociationType, setSubmitStatus, showProfileModal, setShowProfileModal, editMode){

    return function(data){

        const reverseNormalizeData = reverseNormalizeUserData(data);

        const handleProfileSubmit = (submitFunction) => {
            submitFunction(
                medstarAssociationType,
                reverseNormalizeData,
                () => {
                    setShowProfileModal({ ...showProfileModal, showModal: true, success: true });
                    setSubmitStatus('profile-saved');
                },
                (response) => {
                    console.log('BAD RESPONSE',response.response.data.payload.errors);
                    const errors = response?.response?.data?.payload?.errors || []; 
                    setShowProfileModal({ ...showProfileModal, showModal: true, success: false, errors });
                    setSubmitStatus('profile-save-failed');
                }
            );
        };

        editMode === 'update' ? handleProfileSubmit(updateProfile) : handleProfileSubmit(createProfile); 
    }
}
